import { HUBSPOT_BASE_URL, INTERCOM_BASE_URL, NEW_ADMIN_URL } from "environment";
import "./user_form_controller";

angular
  .module("app.views")
  .config(($routeProvider) => {
    $routeProvider.when("/accounts/:account_id/users/:id", {
      template: require("./user.html"),
      controller: "UserController",
    });
  })
  .controller(
    "UserController",
    function (
      $scope,
      $location,
      $routeParams,
      $rootScope,
      $modal,
      Account,
      User,
      Config,
      $route
    ) {
      $scope.roles = angular.copy(Config.roles);
      $scope.account = Account.get({ id: $routeParams.account_id });
      $scope.contact = {};
      $scope.loading = true;
      $scope.verificationResent = false;
      $scope.newAdminURL = NEW_ADMIN_URL;
      const updateUser = (u) => {
        $scope.user = u;
        // Turn roles into role for convenience
        if ($scope.user.roles.length > 0) {
          $scope.user.role = $scope.user.roles[0];
        }
        if (
          $scope.user.hubspot_contact_handle &&
          $scope.user.hubspot_contact_handle.length
        ) {
          $scope.contact = User.contact({
            account_id: $routeParams.account_id,
            id: $routeParams.id,
          })
            .$promise.then((res) => ($scope.contact = res))
            .catch((err) => {
              if (err.status === 404) {
                // Ignore
              } else {
                alert(err);
                console.error(err);
              }
            })
            .finally(() => ($scope.loading = false));
        } else {
          $scope.loading = false;
        }
      };
      $scope.user = User.get({
        account_id: $routeParams.account_id,
        id: $routeParams.id,
      }).$promise.then(updateUser);

      $scope.modalInstance;
      $scope.edit = () => {
        $scope.modalInstance = $modal.open({
          template: require("./user_form.html"),
          controller: "UserFormController",
          size: "lg",
          backdrop: "static",
          resolve: {
            account: () => $scope.account,
          },
        });
        $scope.modalInstance.result.then(updateUser);
      };

      $scope.ok = function () {
        delete $scope.user.roles;
        User.update($scope.user, (u) => $route.reload());

        return;
      };

      $scope.resendVerificationEmail = function () {
        if (
          !confirm(
            "Are you sure you want to resend the verification email to this user?"
          )
        ) {
          return;
        }
        return User.update({
          account_id: $scope.user.account_id,
          id: $scope.user.id,
          requires_verification: true,
        }).$promise.then((res) => {
          $scope.requiresVerification = true;
          $scope.verificationResent = true;
          $scope.user = res;
        });
      };

      $scope.showSuppression = (email) =>
        $location.url(`/suppressed_emails/${email}`);

      $scope.hubspotContactUrl = () =>
        `${HUBSPOT_BASE_URL}/contact/${$scope.user.hubspot_contact_handle}`;

      $scope.intercomContactUrl = () =>
        `${INTERCOM_BASE_URL}/users/${$scope.user.intercom_contact_id}`;
    }
  );



// WEBPACK FOOTER //
// ./views/user/user_controller.js